import React from "react"
import DatePicker from "react-datepicker"

import SelectTags from "../../common/tags/SelectTags"

import {
    communityTypes,
    communitySources,
    communityStatuses
} from "../../../config/application-definitions"

const CommunityFilterForm = ({
    model,
    onEventChange,
    onValueChange,
    onLabelsSearch,
    onSystemLabelsSearch,
    onTopicsSearch,
    onDimensionsSearch,
    onProjectsSearch,
    onCommunitiesSearch,
    onUsersSearch
}) => (
    <form name="filterform">
        <div className="filter-block">
            <label htmlFor="name">Name</label>
            <input
                name="name"
                className="form-control"
                type="text"
                placeholder="Name"
                value={model.name}
                onChange={onEventChange}
            />
        </div>
        <div className="filter-block">
            <label htmlFor="privacy">Type</label>
            <select
                name="privacy"
                className="form-control"
                value={model.privacy}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {Object.keys(communityTypes).map(value => (
                    <option value={value} key={value}>
                        {communityTypes[value]}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label htmlFor="source">Source</label>
            <select
                name="source"
                className="form-control"
                value={model.source}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {communitySources.map(value => (
                    <option value={value} key={value}>
                        {value}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label htmlFor="status">Status</label>
            <select
                name="status"
                className="form-control"
                value={model.status}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {communityStatuses.map(value => (
                    <option value={value} key={value}>
                        {value}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label htmlFor="labels">Labels</label>
            <div className="filter-tags">
                <SelectTags
                    name="labels"
                    value={model.labels}
                    loadOptions={onLabelsSearch}
                    placeholder="Labels"
                    autoload={true}
                    onChange={onValueChange("labels")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="system-labels">System labels</label>
            <div className="filter-tags">
                <SelectTags
                    name="system-labels"
                    value={model.system_labels}
                    loadOptions={onSystemLabelsSearch}
                    placeholder="System labels"
                    autoload={true}
                    onChange={onValueChange("system_labels")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="parents">Parent communities</label>
            <div className="filter-tags">
                <SelectTags
                    name="parents"
                    value={model.parents}
                    loadOptions={onCommunitiesSearch}
                    placeholder="Parent communities"
                    onChange={onValueChange("parents")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="sub-communities">Sub-communities</label>
            <div className="filter-tags">
                <SelectTags
                    name="sub-communities"
                    value={model.sub_communities}
                    loadOptions={onCommunitiesSearch}
                    placeholder="Sub-communities"
                    onChange={onValueChange("sub_communities")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="sub-groups">Sub-groups</label>
            <div className="filter-tags">
                <SelectTags
                    name="sub-groups"
                    value={model.sub_groups}
                    loadOptions={onCommunitiesSearch}
                    placeholder="Sub-groups"
                    onChange={onValueChange("sub_groups")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label>Related</label>
            <div className="filter-tags">
                <SelectTags
                    value={model.topics}
                    loadOptions={onTopicsSearch}
                    placeholder="Insight areas"
                    onChange={onValueChange("topics")}
                />
            </div>
            <div className="filter-tags">
                <SelectTags
                    value={model.dimensions}
                    loadOptions={onDimensionsSearch}
                    placeholder="Key issues"
                    onChange={onValueChange("dimensions")}
                />
            </div>
            <div className="filter-tags">
                <SelectTags
                    value={model.projects}
                    loadOptions={onProjectsSearch}
                    placeholder="Projects"
                    onChange={onValueChange("projects")}
                />
            </div>
            <div className="filter-tags">
                <SelectTags
                    value={model.communities}
                    loadOptions={onCommunitiesSearch}
                    placeholder="Communities"
                    onChange={onValueChange("communities")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="users">
                Community Participants (Members, Managers, Followers)
            </label>
            <div className="filter-tags">
                <SelectTags
                    name="users"
                    value={model.users}
                    loadOptions={onUsersSearch}
                    placeholder="Community Participants"
                    onChange={onValueChange("users")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="creators">Created by</label>
            <div className="filter-tags">
                <SelectTags
                    name="creators"
                    value={model.creators}
                    loadOptions={onUsersSearch}
                    placeholder="Created by"
                    onChange={onValueChange("creators")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="updated-by">Updated by</label>
            <div className="filter-tags">
                <SelectTags
                    name="updated-by"
                    value={model.updated_by}
                    loadOptions={onUsersSearch}
                    placeholder="Updated by"
                    onChange={onValueChange("updated_by")}
                />
            </div>
        </div>
        <div className="filter-block filter-dates clearfix">
            <div className="form-group start-date-group">
                <label htmlFor="create_start_date">Create start date</label>
                <DatePicker
                    name="create_start_date"
                    selectsStart
                    placeholder="Create start date"
                    className="form-control"
                    selected={model.create_start_date}
                    startDate={model.create_start_date}
                    endDate={model.create_end_date}
                    onChange={onValueChange("create_start_date")}
                />
            </div>
            <div className="form-group end-date-group">
                <label htmlFor="create_end_date">Create end date</label>
                <DatePicker
                    name="create_end_date"
                    selectsEnd
                    placeholder="Create end date"
                    className="form-control"
                    selected={model.create_end_date}
                    startDate={model.create_start_date}
                    endDate={model.create_end_date}
                    onChange={onValueChange("create_end_date")}
                />
            </div>
        </div>
        <div className="filter-block filter-dates clearfix">
            <div className="form-group start-date-group">
                <label htmlFor="updated_start_date">Updated start date</label>
                <DatePicker
                    name="updated_start_date"
                    selectsStart
                    placeholder="Updated start date"
                    className="form-control"
                    selected={model.updated_start_date}
                    startDate={model.updated_start_date}
                    endDate={model.updated_end_date}
                    onChange={onValueChange("updated_start_date")}
                />
            </div>
            <div className="form-group end-date-group">
                <label htmlFor="updated_end_date">Updated end date</label>
                <DatePicker
                    name="updated_end_date"
                    selectsEnd
                    placeholder="Updated end date"
                    className="form-control"
                    selected={model.updated_end_date}
                    startDate={model.updated_start_date}
                    endDate={model.updated_end_date}
                    onChange={onValueChange("updated_end_date")}
                />
            </div>
        </div>
    </form>
)

export default CommunityFilterForm
